import { Component } from "@kluntje/core";
import { addClass } from "@kluntje/js-utils/lib/dom-helpers";
import { INVISIBLE, LOADED } from "Helper/cssClasses";

class FRASearchResultOverview extends Component {
  constructor() {
    super({
      ui: {
        loadMoreBtn: ".fra-js-search-result-overview__load-more-cta:-one",
        teasers: ".fra-js-search-result-teaser",
      },
      events: [
        {
          event: "click",
          target: "loadMoreBtn",
          handler: "loadMoreTeasers",
        },
      ],
      initialStates: {
        loadedTeasers: 0,
      },
      reactions: {
        loadedTeasers: ["handleTeaserLoad"],
      },
    });
  }

  /**
   * Returns number of initially loaded teasers
   * @returns {number}
   */
  get initialTeaserCount(): number {
    return 6;
  }

  /**
   * Returns number of teaser to load by clicking loadMoreBtn
   * @returns {number}
   */
  get loadMoreTeaserCount(): number {
    return 6;
  }

  /**
   * returns the index of the last available teaser
   * @returns {number}
   */
  get lastTeaser(): number {
    return this.ui.teasers.length - 1;
  }

  /**
   * initially sets loadedTeaser state
   */
  afterComponentRender(): void {
    this.setState({ loadedTeasers: this.initialTeaserCount });
  }

  /**
   * Handles teaserLoad, by setting loaded class on all loaded teasers
   */
  handleTeaserLoad({ loadedTeasers }: any): void {
    for (let teaserIdx = 0; teaserIdx < loadedTeasers; teaserIdx++) {
      addClass(this.ui.teasers[teaserIdx], LOADED);
    }
  }

  /**
   * Loads additional row of teasers
   */
  loadMoreTeasers(): void {
    const lastNeededTeaser = this.getLastNeededTeaser(this.loadMoreTeaserCount);

    if (lastNeededTeaser >= this.lastTeaser) addClass(this.ui.loadMoreBtn, INVISIBLE);

    this.setState({ loadedTeasers: lastNeededTeaser + 1 });
    this.uiloadMoreBtn.blur();
  }

  /**
   * Helper to get index of the last teaser to load
   * @param {number} additionalTeaserCount - number of teaser to load
   * @returns {number}
   */
  getLastNeededTeaser(additionalTeaserCount: number): number {
    let lastNeededTeaser = this.state.loadedTeasers + additionalTeaserCount - 1;
    if (lastNeededTeaser >= this.lastTeaser) lastNeededTeaser = this.lastTeaser;

    return lastNeededTeaser;
  }
}

customElements.define("fra-m-search-result-overview", FRASearchResultOverview);

export default FRASearchResultOverview;
